export default __webpack_public_path__ + "static/media/national_medical_asociation@3x.d5f0e17c.png";